import { c as _c } from "react/compiler-runtime";
import { LinkButton, LoadingSpinner } from '@onefootprint/ui';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import TimelineItemRow from './components/timeline-item-row/timeline-item-row';
export type TimelineItem = {
  timestamp?: string;
  iconComponent?: React.ReactNode; // If icon is not provided, we show a dashed line between prev and next items
  headerComponent: React.ReactNode;
  bodyComponent?: React.ReactNode;
};
type TimelineProps = {
  items: TimelineItem[];
  isPending?: boolean;
  pagination?: {
    hasNextPage: boolean;
    fetchNextPage: () => void;
  };
};
const Timeline = t0 => {
  const $ = _c(25);
  const {
    items,
    isPending,
    pagination
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.timeline"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  if (!isPending && !items.length) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <p className="text-body-2">{t2}</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let allItems;
  if ($[5] !== isPending || $[6] !== items || $[7] !== pagination || $[8] !== t) {
    allItems = [...items];
    if (pagination?.hasNextPage) {
      let t2;
      if ($[10] !== pagination) {
        t2 = () => pagination.fetchNextPage();
        $[10] = pagination;
        $[11] = t2;
      } else {
        t2 = $[11];
      }
      let t3;
      if ($[12] !== t) {
        t3 = t(_temp2);
        $[12] = t;
        $[13] = t3;
      } else {
        t3 = $[13];
      }
      let t4;
      if ($[14] !== isPending || $[15] !== t2 || $[16] !== t3) {
        t4 = {
          headerComponent: <LinkButton disabled={isPending} onClick={t2}>{t3}</LinkButton>,
          iconComponent: null
        };
        $[14] = isPending;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
      } else {
        t4 = $[17];
      }
      allItems.push(t4);
    }
    $[5] = isPending;
    $[6] = items;
    $[7] = pagination;
    $[8] = t;
    $[9] = allItems;
  } else {
    allItems = $[9];
  }
  let t2;
  if ($[18] !== allItems) {
    t2 = <div className="z-0 flex flex-col">{allItems.map((item, i) => <TimelineItemRow key={item.timestamp ?? "show-more"} item={item} i={i} allItems={allItems} />)}</div>;
    $[18] = allItems;
    $[19] = t2;
  } else {
    t2 = $[19];
  }
  let t3;
  if ($[20] !== isPending) {
    t3 = isPending && <div className="flex items-center justify-center p-6 w-full"><LoadingSpinner /></div>;
    $[20] = isPending;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== t2 || $[23] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
};
export default Timeline;
function _temp($) {
  return $.empty;
}
function _temp2($_0) {
  return $_0.showMore;
}